export default "__VITE_ASSET__BltQCDUc__"